import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Col from './col.vue'

export const colProps = buildProps({})

export type ColProps = ExtractPropTypes<typeof colProps>
export type ColInstance = InstanceType<typeof Col>
